import React from "react";
import MxButton from "./MxButton";
import SparklesIcon from "@icons-rf/sparkles.svg?react";
import { CircularProgress } from "@mui/material";
import MxLoading from "@rf-l1/loading/MxLoading";
import MxButton2 from "./MxButton2";

interface MxButtonIaProps {
  onClick?: () => void;
  loading?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
}

const MxButtonIa = (props: MxButtonIaProps) => {
  const { loading, ...rest } = props;
  return (
    <MxButton2
      {...rest}
      type={props.type}
      testId="mx-button-ia"
      variant="contained"
      disabled={props.disabled}
      endIcon={<SparklesIcon width={20} height={20} />}
      loading={loading}
      textColor="primary.contrastText"
      gradientMode={{
        start: "primary.main",
        end: "primary.light",
        direction: "to right"
      }}
    />
  );
};

export default MxButtonIa;
